import React, {useCallback} from 'react';
import {DataRow} from '../../../components';
import {t} from '../../../localization';
import {TeamMember, useMembershipsOperations} from '../../../services';
import {DataContainer} from '../Components';

type Props = {
  member: TeamMember | undefined;
  disabled: boolean;
  onEditModeChanged: (t: boolean) => void;
};

export const ReceivesShiftsEditor: React.FC<Props> = ({
  member,
  disabled,
  onEditModeChanged,
}) => {
  const {update} = useMembershipsOperations();

  const handleToggle = useCallback(() => {
    return member?.membershipId
      ? update(member?.membershipId, {
          autoAssignShifts: !member.autoAssignShifts,
        })
      : undefined;
  }, [member?.autoAssignShifts, member?.membershipId, update]);

  return (
    <DataContainer>
      <DataRow
        label={t('screens.member.fields.receivesshifts')}
        data={member?.autoAssignShifts ?? false}
        kind="Toggle"
        disabled={disabled}
        onToggle={handleToggle}
        onEditModeChanged={onEditModeChanged}
      />
    </DataContainer>
  );
};
